export default __webpack_public_path__ + "static/selfcheck~HedqmMTb-950d7b157092fc34fe77695c898a77e0.png";